export default __webpack_public_path__ + "static/media/responsible-person.8109978e.svg";